export function connectCashModule(url, handlers = {}) {
    const {
        onOpen,
        onClose,
        onError,
        onStateChanged,
        onSessionStarted,
        onCoinAccepted,
        onCoinRejected,
        onSessionComplete,
        onSessionCancelled,
    } = handlers;

    let socket;
    try {
        socket = new WebSocket(url);
    } catch (error) {
        console.warn('cashModuleClient: failed to construct WebSocket', url, error);
        if (onError) onError(error);
        return {
            getState: () => {},
            startSession: () => {},
            cancelSession: () => {},
            close: () => {},
        };
    }

    socket.onopen = () => {
        if (onOpen) onOpen();
    };

    socket.onclose = () => {
        if (onClose) onClose();
    };

    socket.onerror = (event) => {
        if (onError) onError(event);
    };

    socket.onmessage = (event) => {
        let message;
        try {
            message = JSON.parse(event.data);
        } catch (error) {
            console.warn('cashModuleClient: received unparsable message', event.data, error);
            return;
        }

        switch (message.type) {
            case 'StateChanged':
                if (onStateChanged) onStateChanged(message.state);
                break;
            case 'SessionStarted':
                if (onSessionStarted) onSessionStarted(message);
                break;
            case 'CoinAccepted':
                if (onCoinAccepted) onCoinAccepted(message);
                break;
            case 'CoinRejected':
                if (onCoinRejected) onCoinRejected(message);
                break;
            case 'SessionComplete':
                if (onSessionComplete) onSessionComplete(message);
                break;
            case 'SessionCancelled':
                if (onSessionCancelled) onSessionCancelled(message);
                break;
            default:
                console.warn('cashModuleClient: unknown message type', message.type);
        }
    };

    function send(message) {
        if (socket.readyState !== WebSocket.OPEN) {
            console.warn('cashModuleClient: cannot send, socket not open', message);
            return;
        }
        socket.send(JSON.stringify(message));
    }

    return {
        getState: () => send({ type: 'GetState' }),
        startSession: (totalAmountCents) => send({ type: 'StartSession', totalAmountCents }),
        cancelSession: () => send({ type: 'CancelSession' }),
        close: () => socket.close(),
    };
}
